import { Button } from '@pm/ui';
import { Pause } from 'lucide-react';
import { Link } from 'react-router';
import { api } from '@/lib/api';
import { mgKeys, useInvalidating, useRunningTimer } from '@/lib/queries';
import { useToast } from '@/lib/toast';
import { Elapsed } from './TimePanel';

/** Indicador global do cronômetro na topbar. */
export function RunningTimer() {
  const toast = useToast();
  const { data } = useRunningTimer();
  const stop = useInvalidating(
    (taskId: string) => api.post(`/tasks/${taskId}/time/stop`, {}),
    [mgKeys.timer, ['task-time'], ['task']],
  );
  if (!data) return null;
  return (
    <div className="hidden items-center gap-1.5 rounded border border-accent-border bg-accent-soft px-2 py-0.5 text-xs md:flex">
      <span className="size-1.5 animate-pulse rounded-full bg-accent" aria-hidden />
      <Link
        to={`/tasks/${data.task.id}`}
        className="max-w-[160px] truncate text-text-2 hover:text-text-1"
      >
        #{data.task.number} {data.task.title}
      </Link>
      <Elapsed since={data.started_at} className="font-mono text-accent" />
      <Button
        variant="ghost"
        size="icon-sm"
        className="size-5"
        aria-label="Parar cronômetro"
        loading={stop.isPending}
        onClick={() =>
          stop.mutate(data.task.id, {
            onSuccess: () => toast.success('Tempo registrado'),
            onError: (e) => toast.error(e),
          })
        }
      >
        <Pause />
      </Button>
    </div>
  );
}
